<template>
  <div class="main">
    <div class="m-main-wrap">
      <div class="m-area u-mb20">
        <div class="c-search">
          <input
            type="text"
            class="c-input"
            v-model="keyword"
            placeholder="请输入文件名称"
          />
          <span class="icon icontemp search" @click="search()"></span>
        </div>
      </div>
      <div class="m-area">
        <div class="c-file-list" v-for="o in list" :key="o.fileId">
          <div class="file-con">
            <div class="file-format">
              <img :src="`./images/${o.typeExt}.png`" />
            </div>
            <div class="file-main">
              <div class="file-name">{{ o.name }}</div>
              <ul class="file-tips">
                <li>最后下载时间：{{ o.lastDownloadTime }}</li>
                <li>下载次数：{{ o.downLoadTimes || 0 }}</li>
                <li>下载邮箱：{{ o.toEmail || "--" }}</li>
              </ul>
            </div>
          </div>
          <div class="file-ope">
            <button class="m-bind" @click="showModal(o)">
              <span class="icon icontemp download-b"></span>
              <span class="text">重新下载</span>
            </button>
            <a :href="o.owViewUrl" target="_blank">
              <button class="m-bind">
                <span class="icon icontemp view"></span>
                <span class="text">预览</span>
              </button>
            </a>
          </div>
        </div>
      </div>
      <div class="m-pagination u-mt30" v-if="list.length > 0">
        <a-pagination
          @change="onChange"
          :defaultPageSize="pageSizeOptions"
          :total="total"
          :current="current"
        ></a-pagination>
      </div>

      <div class="m-area u-mt40" v-if="!isLoading && list.length === 0">
        <a-empty description="暂无数据"></a-empty>
      </div>
<!--      <div class="m-loading-data" v-if="isLoading"></div>-->
    </div>
    <a-modal
      title="请输入邮箱"
      :visible="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
      @cancel="handleCancel"
      :destroyOnClose="true"
      cancelText="取消"
      okText="确定"
    >
      <div class="c-form">
        <div class="form-row">
          <div class="form-contro u-pl0">
            <input
              type="text"
              class="form-input"
              v-model="downEmail"
              @change="downEmailChange()"
            />
          </div>
          <div class="form-error u-pl0" v-if="downError">
            {{ downErrorText }}
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { cr } from "fire-wind-water/core";
import member from "../../services/member";
import { ow365Url, sess, tenantId } from "../../common/sbase";
import { FileTypeJosn } from "../../common/setting";
import moment from "moment";

export default {
  name: "File",
  data() {
    return {
      keyword: "",
      current: 1,
      total: 0,
      pageSizeOptions: 20,
      isLoading: true,
      list: [],
      visible: false,
      confirmLoading: false,
      downEmail: "",
      downError: false,
      downErrorText: "",
      fileId: null
    };
  },
  methods: {
    getList() {
      const info = {
        keyword: this.keyword,
        sess: sess,
        start: (this.current - 1) * this.pageSizeOptions,
        num: this.pageSizeOptions
      };
      this.isLoading = true;
      member.downFileList(info).subscribe(data => {
        this.isLoading = false;
        window.$sk.loading.hide();
        if (data.result == 0) {
          this.total = data.content.total;
          this.list = data.content.items;
          this.initList();
        } else {
          this.$message.error(data.desc);
        }
      });
    },
    initList() {
      cr.each(this.list, d => {
        d.typeExt = FileTypeJosn[d.extendName] || "other";
        d.lastDownloadTime = moment(d.lastDownloadTime * 1000).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        const url = /^https/.test(d.fileUrl) ? d.fileUrl + "&ssl=1" : d.fileUrl;
        d.owViewUrl = ow365Url + url;
      });
    },
    search() {
      this.current = 1;
      this.getList();
    },
    onChange(current) {
      this.current = current;
      this.getList();
    },
    downEmailChange() {
      this.downErrorText = "";
      this.downError = false;
      if (!this.downEmail) {
        this.downErrorText = "请输入邮箱";
        this.downError = true;
      } else {
        let reg = /^(\w)+(.|-\w+)*@(.|-|\w)+((\.\w+)+)$/g;
        if (!reg.test(this.downEmail)) {
          this.downErrorText = "邮箱格式不正确";
          this.downError = true;
        }
      }
    },
    showModal(o) {
      this.visible = true;
      this.confirmLoading = false;
      this.downEmail = "";
      this.fileId = o.fileId;
    },
    handleOk() {
      if (!this.downError) {
        this.downEmailChange();
      }
      if (this.downError) {
        return;
      }
      this.confirmLoading = true;
      this.downEmailSend();
    },
    handleCancel() {
      this.visible = false;
    },
    downEmailSend() {
      const info = {
        fileList: [this.fileId],
        extra: {
          tenantId: tenantId
        },
        sess: sess,
        email: this.downEmail
      };
      member.downloadWithEmail(info).subscribe(data => {
        this.confirmLoading = false;
        if (data.result == 0) {
          this.visible = false;
          this.$message.success("已下载至您的邮箱");
        } else {
          this.$message.error(data.desc);
        }
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style scoped></style>
